
import { PerfilesId } from 'src/utils/perfil';
import * as Yup from 'yup';


export const esquemaDeValidacionNuevoUsuarioUnidad = Yup.object({
  tipoIdentificacion: Yup.string().required("El tipo de identificación es obligatorio"),
  identificacion: Yup.string().required("La identificación es obligatoria"),
  primerNombre: Yup.string().required("El primer nombre es obligatorio"),
  primerApellido: Yup.string().required("El primer apellido es obligatorio"),
  segundoApellido: Yup.string().required("El segundo apellido es obligatorio"),
  fechaNacimiento: Yup.string().required("La fecha de nacimiento es obligatoria"),
  sexo: Yup.string().required("El sexo es obligatorio"),
  correoElectronico: Yup.string().required("El correo es obligatorio").email('Formato inválido'),
  numeroCelular: Yup.string().required("El número de celular es obligatorio").matches(/^\d+$/, "Solo se permiten números"),
  departamentoResidenciaId: Yup.string().required("El departamento es obligatorio"),
  municipioResidenciaId: Yup.string().required("El municipio es obligatorio"),
  perfilId: Yup.string().required("El perfil es obligatorio"),
  nombreInstitucion: Yup.string().required("El nombre de la institución es obligatorio"),
  nombrePrograma: Yup.string().required("El nombre del programa es obligatorio"),
  fechaGraduacion: Yup.string()
  .when('perfilId', ([perfilId]: any, sch: any) => {
    return [PerfilesId.MENTOR, PerfilesId.EJECUTORINGLES, PerfilesId.EJECUTOR_HABILIDADES_PODER, PerfilesId.EJECUTOR_TECNICO].indexOf(perfilId) > -1
      ? sch
          .trim()
          .required("La fecha de graduación es obligatoria")
      : sch.notRequired();
  }),
  fechaExpedicionTarjetaProfesional:  Yup.string()
  .when('perfilId', ([perfilId]: any, sch: any) => {
    return [PerfilesId.MENTOR, PerfilesId.EJECUTORINGLES, PerfilesId.EJECUTOR_HABILIDADES_PODER, PerfilesId.EJECUTOR_TECNICO].indexOf(perfilId) > -1
      ? sch
          .trim()
          .required("La fecha de expedición de la tarjeta profesional es obligatoria")
      : sch.notRequired();
  }),
  soporteId: Yup.string()
  .when('perfilId', ([perfilId]: any, sch: any) => {
    return [PerfilesId.MENTOR, PerfilesId.EJECUTORINGLES, PerfilesId.EJECUTOR_HABILIDADES_PODER, PerfilesId.EJECUTOR_TECNICO].indexOf(perfilId) > -1
      ? sch
          .trim()
          .required("El acta de graduación es obligatoria")
      : sch.notRequired();
  }),

});

export const setValoresInicialesUsuarioUnidad = (valores: IinformacionBasicaForm) => {
  return {
    tipoIdentificacion: valores.tipoIdentificacion,
    identificacion: valores.identificacion,
    primerNombre: valores.primerNombre,
    segundoNombre: valores.segundoNombre,
    primerApellido: valores.primerApellido,
    segundoApellido: valores.segundoApellido,
    fechaNacimiento: valores.fechaNacimiento,
    sexo: valores.sexo,
    correoElectronico: valores.correoElectronico,
    numeroCelular: valores.numeroCelular,
    departamentoResidenciaId: valores.departamentoResidenciaId,
    municipioResidenciaId: valores.municipioResidenciaId,
    perfilId: valores.perfilId,
    nombreInstitucion: valores.nombreInstitucion,
    nombrePrograma: valores.nombrePrograma,
    nivelFormacion: valores.nivelFormacion,
    fechaGraduacion: valores.fechaGraduacion,
    soporteId: valores.soporteId,
    horariosDisponibles: valores.horariosDisponibles,
    sedesDisponibles: valores.sedesDisponibles,
    fechaExpedicionTarjetaProfesional: valores.fechaExpedicionTarjetaProfesional
  }
}

export const valoresInicialesInformacionBasica: IinformacionBasicaForm = {
  tipoIdentificacion: 'CEDULA_DE_CIUDADANIA',
  identificacion: '',
  primerNombre: '',
  segundoNombre: '',
  primerApellido: '',
  segundoApellido: '',
  fechaNacimiento: '',
  sexo: '',
  correoElectronico: '',
  numeroCelular: '',
  departamentoResidenciaId: '',
  municipioResidenciaId: '',
  perfilId: '',
  nombreInstitucion: '',
  nombrePrograma: '',
  nivelFormacion: '',
  fechaGraduacion: '',
  soporteId: '',
  horariosDisponibles:  [],
  sedesDisponibles:  [],
  fechaExpedicionTarjetaProfesional: ''
}

export interface FormacionAcademica {
  nivelFormacion: string,
  nombrePrograma: string,
  nombreInstitucion: string,
  fechaGraduacion: string,
  soporteId: string
  
}

export interface IinformacionBasicaForm {
  tipoIdentificacion?: string;
  identificacion?: string;
  primerNombre?: string;
  segundoNombre?: string;
  primerApellido?: string;
  segundoApellido?: string;
  fechaNacimiento?: string;
  sexo?: string;
  correoElectronico?: string;
  numeroCelular?: string;
  departamentoResidenciaId?: string;
  municipioResidenciaId?: string;
  perfilId: string;
  nombrePrograma: string;
  nivelFormacion: string;
  nombreInstitucion: string;
  fechaGraduacion: string;
  soporteId: string;
  horariosDisponibles: string [],
  sedesDisponibles: string [],
  fechaExpedicionTarjetaProfesional: string
}

// Buscar persona STEP
export interface IbuscarPersonaForm {
  tipoIdentificacion: string,
  identificacion: string,
  tipoPersona: string,
}

export const valoresInicialesBuscarPersona: IbuscarPersonaForm = {
  tipoIdentificacion: "",
  identificacion: "",
  tipoPersona: "NATURAL",
};

export const esquemaDeValidacionBuscarPersona = Yup.object({
  tipoIdentificacion: Yup.string().required("El tipo de identificación es obligatorio"),
  identificacion: Yup.string().required("La identificación es obligatoria"),
});
